import { Label } from "office-ui-fabric-react"
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";
import { UserState, actionCreators  } from "../../../store/User";
import PresentationModeToggle from "./PresentationModeToggle";

type OwnProps = {};
type StateProps = {
    user: UserState;
}
type ActionProps = typeof actionCreators;
type Props = OwnProps & StateProps & ActionProps;

const PresentationModePersonalSettings = (props: Props) => {
    return <div className="presentation-mode-settings">
        <Label className="section-header">Presentation Mode Settings</Label>
        <PresentationModeToggle 
            value={props.user.preferences.presentationMode}
            onChange={(v) => props.updatePreferences({ presentationMode: v })} />
    </div>
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps, actionCreators)(PresentationModePersonalSettings);